import * as React from "react";

import { StatusBanner } from "@/components/feature/StatusBanner";

/**
 * LoginFailed — der angemeldete Benutzer darf das Add-in nicht verwenden.
 *
 * Endzustand: es gibt kein Formular darunter, aber die Darstellung entspricht
 * den übrigen Rückmeldungen.
 */
const LoginFailed = () => (
  <div className="px-[1.6rem]">
    <StatusBanner
      tone="danger"
      title="Keine Berechtigung"
      className="mt-[1.2rem]"
    >
      Sie besitzen nicht die erforderlichen Berechtigungen, um sich hier
      anzumelden. Bitte wenden Sie sich an{" "}
      <a
        href="mailto:servicedesk@vocom.ch?subject=ePortier%20Outlook%20Add-In%20/%20Support"
        className="font-semibold text-foreground underline"
      >
        servicedesk@vocom.ch
      </a>
      .
    </StatusBanner>
  </div>
);

export default LoginFailed;
